import { render } from "./PopupChuThich.vue?vue&type=template&id=3a4937ec&scoped=true"
import script from "./PopupChuThich.vue?vue&type=script&lang=js"
export * from "./PopupChuThich.vue?vue&type=script&lang=js"

import "./PopupChuThich.vue?vue&type=style&index=0&id=3a4937ec&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4937ec"]])

export default __exports__